import { mediaTypeFromFileName } from "../../../shared/attachmentPolicy";
import type { StoredSkillFile } from "../../../shared/skills/spec";
import { triggerDownload } from "../FileRender/download";

function bytesToBase64(bytes: Uint8Array): string {
  let binary = "";
  for (let offset = 0; offset < bytes.length; offset += 32_768) {
    binary += String.fromCharCode(...bytes.subarray(offset, offset + 32_768));
  }
  return btoa(binary);
}

function base64ToBytes(content: string): Uint8Array<ArrayBuffer> {
  const binary = atob(content);
  const bytes = new Uint8Array(new ArrayBuffer(binary.length));
  for (let index = 0; index < binary.length; index++) {
    bytes[index] = binary.charCodeAt(index);
  }
  return bytes;
}

export async function readUpload(file: File): Promise<StoredSkillFile> {
  const bytes = new Uint8Array(await file.arrayBuffer());
  try {
    const content = new TextDecoder("utf-8", { fatal: true }).decode(bytes);
    if (!content.includes("\0")) return { content, encoding: "utf8" };
  } catch {
    return { content: bytesToBase64(bytes), encoding: "base64" };
  }
  return { content: bytesToBase64(bytes), encoding: "base64" };
}

export function downloadStoredFile(path: string, file: StoredSkillFile): void {
  const blob = new Blob([
    file.encoding === "utf8" ? file.content : base64ToBytes(file.content),
  ]);
  const url = URL.createObjectURL(blob);
  triggerDownload(url, path.split("/").at(-1) ?? path);
  URL.revokeObjectURL(url);
}

// A data: URL for the file's bytes, typed by extension so FileRender routes it
// to the right viewer (image, pdf, …). A data: URL (not blob:) because our CSP
// permits fetching data: but not blob:.
export function dataUrlForStoredFile(
  path: string,
  file: StoredSkillFile
): string {
  const base64 =
    file.encoding === "base64"
      ? file.content
      : bytesToBase64(new TextEncoder().encode(file.content));
  return `data:${mediaTypeFromFileName(path)};base64,${base64}`;
}
